"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _TextInput = _interopRequireDefault(require("../TextInput"));

var _validationRules = require("./validationRules");
/** Fields to enter email addresses and validate formatting */


var EmailInput = function EmailInput(_ref) {
  var _ref$allowMultiple = _ref.allowMultiple,
      allowMultiple = _ref$allowMultiple === void 0 ? false : _ref$allowMultiple,
      _ref$delimiter = _ref.delimiter,
      delimiter = _ref$delimiter === void 0 ? ";" : _ref$delimiter,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "vertical" : _ref$layout,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      other = (0, _objectWithoutProperties2["default"])(_ref, ["allowMultiple", "delimiter", "disabled", "layout", "readOnly"]);

  var getError = function getError(label, value) {
    return (0, _validationRules.validationRules)(label, value, allowMultiple, delimiter);
  };

  return /*#__PURE__*/_react["default"].createElement(_TextInput["default"], Object.assign({
    delimiter: delimiter,
    disabled: disabled,
    layout: layout,
    readOnly: readOnly,
    getError: getError
  }, other));
};

var _default = EmailInput;
exports["default"] = _default;